export default "__VITE_ASSET__d5346d46__"